// extracted by mini-css-extract-plugin
export default {"button":"ReturnMenuButton__button--6c0He"};